(function() {
    "use strict";

    if (!String.prototype.trimRight) {
        var regex = /^(.*?)\s*$/;
        
        String.prototype.trimRight = function() {
            return this.replace(regex, "$1");
        };
    }
})();


// WEBPACK FOOTER //
// ./content/js/PrototypeExtensions/String.trimRight.js